<template>
    <div>
        <ul class="nav nav-tabs nav-tabs-highlight mb-0" :class="[ bgClass, { 'pl-2 pt-2': card } ]">
            <li v-for="(tab, index) in tabs" :key="'tab-' + index + 1" class="nav-item">
                <a :href="'#' + (tab.slot ? tab.slot : `tab-${index + 1}`)" class="nav-link" @click.prevent="active_tab_index = index + 1" :class="{ 'active': active_tab_index === index + 1 }">
                    <i v-if="tab.icon_before" class="mr-1" :class="tab.icon_before"></i>{{ tab.label }}<i v-if="tab.icon_after" class="ml-1" :class="tab.icon_after"></i>
                </a>
            </li>
        </ul>

        <div class="tab-content card-body bg-white" :class="{ 'card border-top-0 rounded-top-0 mb-0': !card }">
            <div v-for="(tab, index) in tabs" :key="'tab-pane-' + index + 1" class="tab-pane fade" :id="(tab.slot ? tab.slot : `tab-${index + 1}`)"
                :class="{ 'show': active_tab_index === index + 1, 'active': active_tab_index === index + 1, 'tab-pane-negative-margin': tab.negative_margin }">
                <slot v-if="$scopedSlots[(tab.slot ? tab.slot : `tab-${index + 1}`)] && (keepMounted || active_tab_index === index + 1)" :name="(tab.slot ? tab.slot : `tab-${index + 1}`)"></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LimitlessTabs',
    props: {
        value: {
            type: Number,
            default: 1,
        },
        keepMounted: {
            type: Boolean,
            default: false,
        },
        bgClass: {
            type: String,
            default: '',
        },
        card: {
            type: Boolean,
            default: false,
        },
        tabs: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return { active_tab_index: this.value };
    },
    watch: {
        value(value) {
            this.active_tab_index = value;
        },
        active_tab_index(value) {
            this.$emit('input', value);
        },
    },
};
</script>

<style scoped>
.tab-pane-negative-margin {
    margin: -20px;
}
</style>
